import { useState, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

interface CheckFeatureResponse {
  hasFeature: boolean;
}

export function useFeatureEntitlement(
  companyId: string | undefined,
  feature: string
): { hasFeature: boolean; loading: boolean } {
  const requestKey = companyId ? `${companyId}:${feature}` : null;
  const [hasFeature, setHasFeature] = useState(false);
  const [loading, setLoading] = useState(true);
  const [resolvedKey, setResolvedKey] = useState<string | null>(null);

  useEffect(() => {
    setHasFeature(false);
    setLoading(Boolean(companyId));
    setResolvedKey(null);
    if (!companyId) {
      return;
    }

    const checkFeature = httpsCallable<
      { companyId: string; feature: string },
      CheckFeatureResponse
    >(functions, 'checkFeatureEntitlement');
    let active = true;

    checkFeature({ companyId, feature })
      .then((result) => {
        if (!active) return;
        setHasFeature(result.data.hasFeature);
        setResolvedKey(requestKey);
      })
      .catch(() => {
        if (!active) return;
        setHasFeature(false);
        setResolvedKey(requestKey);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [companyId, feature, requestKey]);

  return {
    hasFeature: resolvedKey === requestKey && hasFeature,
    loading: requestKey !== null && (resolvedKey !== requestKey || loading),
  };
}
